import * as React from "react";
import {
    Button, FormControlLabel, Pagination,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField
} from "@mui/material";

import {useEffect, useState} from "react";
import {IoMdRefreshCircle} from "react-icons/io";
import FunctionsData from "../../../Functions/FunctionsData";
import StaffVetsAddVet from "./StaffVetsAddVet";
import StaffVetsShowTableRow from "./StaffVetsShowTableRow";

export default function StaffVets() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [isOpenForm, setIsOpenForm] = React.useState(false);
    const [currentData, setCurrentData] = React.useState(false);
    const [dataFiltered, setDataFiltered] = React.useState([]);
    const [showInactive, setShowInactive] = useState(false);
    const [showArchived, setShowArchived] = useState(false);
    const [mode, setMode] = useState("new");
    const [filter, setFilter] = useState("");

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [filteredData, setFilteredData] = useState([]);
    const [pageCount, setPageCount] = useState(0);

    // Sorting states
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc'); // or 'desc'

    const handleChange = (event, value) => {
        setPage(value);
    };

    useEffect(() => {
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/vet'),
            setData,
            loading,
            setLoading
        )
    }, [loading]);

    useEffect(() => {
        filterMe();
    }, [data, page, filter, showInactive, showArchived, sortColumn, sortDirection]);

    function filterMe() {
        let d = data;
        let newData = [];

        for (let x in d) {
            let obj = d[x];

            // Filter by active/inactive
            if (showInactive === false && obj?.active === 0) continue;
            if (showInactive === true && obj?.active === 1) continue;

            // Filter by archived/non-archived
            if (showArchived === true && obj?.archived === 0) continue;
            if (showArchived === false && obj?.archived === 1) continue;

            // Check text filter
            let include = false;
            for (let y in obj) {
                let obj2 = obj[y];
                if (filter.trim().toLowerCase() === '' || String(obj2).toLowerCase().includes(filter.trim().toLowerCase())) {
                    include = true;
                }
            }

            if (include === true) {
                newData.push(obj);
            }
        }

        // Sort data if sortColumn is set
        if (sortColumn) {
            newData.sort((a, b) => {
                const aVal = a[sortColumn] || '';
                const bVal = b[sortColumn] || '';
                if (aVal < bVal) return sortDirection === 'asc' ? -1 : 1;
                if (aVal > bVal) return sortDirection === 'asc' ? 1 : -1;
                return 0;
            });
        }

        setPageCount(Math.ceil(newData.length / itemsPerPage));
        // Slice for pagination
        setFilteredData(newData.slice((page - 1) * itemsPerPage, page * itemsPerPage));
    }

    async function updateVets(col, val, id) {
        const tkn = await FunctionsData.getCSRFToken();
        let requestOptionsVoucher = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': sessionStorage.sTkn,
                'X-CSRF-Token': tkn.csrf
            },
            body: JSON.stringify({
                [col]: val
            })
        };

        await fetch(FunctionsData.getApiUrl("/api/vet/") + id, requestOptionsVoucher)
            .then(response => response.json())
            .then((res) => {
                let t = data;
                for (let x in t) {
                    if (t[x]['id'] === id) {
                        t[x][col] = val;
                    }
                }
                setData([...t]);
                setLoading(true);
            })
    }

    const openForm = (e, rowId) => {
        e.preventDefault();
        setMode("update");
        setCurrentData(data.find(({ id }) => id === parseInt(rowId)));
        setIsOpenForm(true);
    }

    const openFormNew = () => {
        setMode("new");
        setCurrentData([]);
        setIsOpenForm(true);
    }

    const ShowButtonNew = () => {
        return (
            <div>
                <Button sx={{margin: 2}}
                        variant={"contained"}
                        onClick={openFormNew}
                >
                    Add new vet
                </Button>
                <FormControlLabel
                    control={<Switch checked={showInactive} onChange={() => {
                        setShowInactive(!showInactive);
                    }} />}
                    label="Show inactive"
                />
                <FormControlLabel
                    control={<Switch checked={showArchived} onChange={() => setShowArchived(!showArchived)} />}
                    label="Show archived"
                />
                <FormControlLabel control={<IoMdRefreshCircle size={35} onClick={() => setLoading(true)}/>} label=""/>
            </div>
        )
    }

    // Sorting handler
    const handleSort = (column) => {
        if (sortColumn === column) {
            // Toggle direction
            setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    };

    // A helper to show sort direction indicators
    const sortIndicator = (column) => {
        if (sortColumn === column) {
            return sortDirection === 'asc' ? '▲' : '▼';
        }
        return '';
    };

    return (
        <TableContainer>
            <TextField id="standard-basic" placeholder={"Filter available vets..."}
                       variant="outlined" size={"small"}
                       sx={{width: '100%'}}
                       value={filter}
                       onChange={(e) => setFilter(e.target.value)}
            />
            <ShowButtonNew />
            <div style={{width:'100%', textAlign:'right', marginBottom:20}}>
                <Pagination count={pageCount} page={page} onChange={handleChange} shape={"rounded"} />
            </div>
            {
                isOpenForm === true ?
                    <StaffVetsAddVet
                        setLoading={setLoading}
                        setIsOpen={setIsOpenForm}
                        isOpen={isOpenForm}
                        currentData={currentData}
                        setCurrentData={setCurrentData}
                        mode={mode}
                    />
                    : null
            }
            <Table sx={{minWidth: 650}} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell onClick={() => handleSort('active')} align="center" style={{cursor:'pointer'}}>
                            Active {sortIndicator('active')}
                        </TableCell>
                        <TableCell onClick={() => handleSort('business_name')} style={{cursor:'pointer'}}>
                            Business name {sortIndicator('business_name')}
                        </TableCell>
                        <TableCell onClick={() => handleSort('merco_id')} align="left" style={{cursor:'pointer'}}>
                            Merco ID {sortIndicator('merco_id')}
                        </TableCell>
                        <TableCell onClick={() => handleSort('vendor_id')} align="left" style={{cursor:'pointer'}}>
                            Vendor ID {sortIndicator('vendor_id')}
                        </TableCell>
                        <TableCell onClick={() => handleSort('address')} align="left" style={{cursor:'pointer'}}>
                            Address {sortIndicator('address')}
                        </TableCell>
                        <TableCell onClick={() => handleSort('contact_name')} align="left" style={{cursor:'pointer'}}>
                            Contact {sortIndicator('contact_name')}
                        </TableCell>
                        <TableCell align="left" style={{cursor:'pointer'}}>
                            Linked clinics
                        </TableCell>
                        <TableCell onClick={() => handleSort('capacity')} align="left" style={{cursor:'pointer'}}>
                            Capacity {sortIndicator('capacity')}
                        </TableCell>
                        <TableCell onClick={() => handleSort('terms')} align="left" style={{cursor:'pointer'}}>
                            Terms {sortIndicator('terms')}
                        </TableCell>
                        <TableCell align="left" style={{cursor:'pointer'}}>
                            Agreement
                        </TableCell>
                        <TableCell onClick={() => handleSort('archived')} align="left" style={{cursor:'pointer'}}>
                            Archive {sortIndicator('archived')}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredData?.map((row, idx) => {
                        return (
                            <StaffVetsShowTableRow
                                key={row.id}
                                row={{...row, address: row.formatted_address}}
                                idx={idx}
                                dataFiltered={dataFiltered}
                                setDataFiltered={setDataFiltered}
                                updateVets={updateVets}
                                openForm={openForm}
                                setData={setData}
                                setLoading={setLoading}
                            />
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
